export const CLEAR_CHANGE_PASSWORD = "CLEAR_CHANGE_PASSWORD";
export const CLEAR_CHANGE_PASSWORD_SUCCESS = "CLEAR_CHANGE_PASSWORD_SUCCESS";
export const CLEAR_CHANGE_PASSWORD_FAILED = "CLEAR_CHANGE_PASSWORD_FAILED";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";
